var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "chat-button-container",
      class: { alert: _vm.hasNewMessages },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAlert,
              expression: "showAlert",
            },
          ],
          staticClass: "chat-button-alert",
          style: _vm.config
            ? { backgroundColor: _vm.config.background_color + " !important" }
            : {},
          attrs: {
            tabindex: "0",
            title: _vm.$gettext(
              "Tienes nuevos mensajes - Click para abrir chat"
            ),
          },
          on: {
            click: _vm.toggleChatWindow,
            keyup: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.toggleChatWindow.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                return _vm.toggleChatWindow.apply(null, arguments)
              },
            ],
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.$gettext("¡Tienes nuevos mensajes!")))])]
      ),
      _c("button", {
        class: { active: _vm.isActive, bounce: _vm.isBounce },
        style: _vm.config
          ? { backgroundColor: _vm.config.background_color + " !important" }
          : {},
        attrs: {
          "aria-label": _vm.$gettext("Abrir chat"),
          title: _vm.$gettext("Abrir ventana de chat"),
          id: "chatButton",
          tabindex: "0",
        },
        on: {
          click: _vm.toggleChatWindow,
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.toggleChatWindow.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              )
                return null
              return _vm.toggleChatWindow.apply(null, arguments)
            },
          ],
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }